import { useAuth } from "@clerk/clerk-react";
import { differenceInSeconds } from "date-fns";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import TokenContext from "./TokenContext";

const TokenProvider = ({ children }: { children: React.ReactElement }) => {
  const { getToken } = useAuth();
  const [isReady, setIsReady] = useState(false);
  const tokenRef = useRef<{ token?: string; timestamp?: Date }>({});

  const refreshToken = useCallback(async () => {
    const newToken = await getToken({
      template: "Default",
      skipCache: true,
    });
    tokenRef.current = { token: newToken ?? undefined, timestamp: new Date() };
    setIsReady(true);
  }, [getToken]);

  const isTokenValid = useCallback(() => {
    return (
      !!tokenRef.current.timestamp &&
      differenceInSeconds(new Date(), tokenRef.current.timestamp) < 55
    );
  }, []);

  useEffect(() => {
    void refreshToken();
  }, [refreshToken]);

  const value = useMemo(
    () => ({
      refreshToken,
      isTokenValid,
      isReady,
      tokenRef,
    }),
    [isReady, isTokenValid, refreshToken],
  );

  return (
    <TokenContext.Provider value={value}>{children}</TokenContext.Provider>
  );
};

export default TokenProvider;
